/**
 * UI adapter: UC-43 PlayAudio
 */
import { architectureFeatures } from '../../../infrastructure/config/features';
import { playAudioUseCase } from '../../../infrastructure/di/container';
import { PlayAudioUseCase } from '../../../application/use-cases/PlayAudioUseCase';
import type { AudioAction } from '../../../application/use-cases/PlayAudioUseCase';
import {
  initAudio,
  playSfx,
  startAmbientNoise,
  stopAmbientNoise,
  setVolumes,
  type SoundType,
} from '../../../../services/audioService';

export type { AudioAction, SoundType };

export function resolvePlayAudio(action: AudioAction): void {
  if (architectureFeatures.useAudioPort) {
    playAudioUseCase.execute({ action });
    return;
  }

  switch (action.type) {
    case 'sfx':
      playSfx(action.sound);
      break;
    case 'start_ambient':
      startAmbientNoise();
      break;
    case 'stop_ambient':
      stopAmbientNoise();
      break;
    case 'init':
      initAudio();
      break;
    case 'set_volumes':
      setVolumes(action.master, action.sfx, action.ambient);
      break;
    default:
      break;
  }
}

/** Legacy fallback constructor for tests */
export function executeLegacyPlayAudio(action: AudioAction): void {
  new PlayAudioUseCase({
    audio: {
      initAudio,
      playSfx,
      startAmbientNoise,
      stopAmbientNoise,
      setVolumes,
    },
  }).execute({ action });
}